import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ShowImportDataComponent } from 'src/app/shared/popups/show-import-data/show-import-data.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

@Component({
  selector: 'app-import-history',
  templateUrl: './import-history.component.html',
  styleUrls: ['./import-history.component.scss'],
})
export class ImportHistoryComponent implements OnInit {
  gridData: {
    columnInfo: Array<{ label: string, propertyName: string, sortingName: string }>,
    columnData: Array<any>,
    totalCount: number,
    totalNoOfPages: number,
    showCheckBox: boolean
    showExportBtn: boolean,
    showGraphBtn: boolean
    showSearchBar: boolean,
    showAddBtn: boolean,
    currentPage: number,
    showDeleteBtn: boolean,
    tabsData: Array<any>,
    tabsMainData: Array<any>,
    showAccessConfigBtn: boolean,
    showTitle: boolean,
    showBreadCrumbs: boolean,
    showAuditLog: boolean,
    showPermantDeleteBtn: boolean,
    showRestoreBtn: boolean,
    showImportBtn: boolean,
    showBackBtn: boolean,
    showRefreshFunctinallity: boolean,
    countTabs: Array<any>,
  } = {
      columnInfo: [], columnData: [], totalCount: 0, totalNoOfPages: 0, showCheckBox: false, showExportBtn: false,
      showGraphBtn: false, showSearchBar: true, showAddBtn: false, currentPage: 0, showDeleteBtn: false,
      tabsData: [], tabsMainData: [], showAccessConfigBtn: false, showTitle: true, showBreadCrumbs: false, 
      showAuditLog: false, showPermantDeleteBtn: false, showRestoreBtn: false, showImportBtn: false, showBackBtn: true,
      showRefreshFunctinallity: true,countTabs: []
  };
  tabs = [
    { label: 'Open', totalCount: 0 },
    { label: 'Closed', totalCount: 0 },
  ];
  selectedTypeTabIndex: any = 0;
  selectedTypeTab: any = 'Open';
  currentPage: number = 0;
  selectedSizeToShowData: number = 25;
  searchString: any =null;
  isChangeDetected: boolean = false;
  paginationUrl: any = null;
  showListingPage: boolean = true;
  moduleName: any;
  loggedInUserCompanyID:any;
  selectedYear:any;
  constructor(private httpService: HttpService, private loadingService: LoaderService, 
    private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe,  public mobileResponsiveService: MobileResponsiveService,
    private activatedroute: ActivatedRoute,private encryptionService:EncryptionService) { }


  ngOnInit() {
    this.initilaizeColumn();
  }
  ionViewWillEnter() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.activatedroute.params.subscribe((params: any) => {
      this.moduleName = params.module;
      this.selectedYear = params?.year;
      if(this.moduleName == 'importemployee'){
        this.getImportHistory();
      }
      if(this.moduleName == 'importgoals'){
        this.getImportHistoryGoals();
      }
      if(this.moduleName == 'importDWM'){
        this.getImportDWM();
      }
      if(this.moduleName == 'competencyImport'){
        this.getCompetencyHistoryData();
      }
    })
  }

  initilaizeColumn() {
    this.gridData.columnInfo = [];
    if(this.moduleName != 'importDWM'){
      this.gridData.columnInfo.push({ label: 'Sr.No.', propertyName: 'sNo', sortingName: 'id' });
      this.gridData.columnInfo.push({ label: 'User Name', propertyName: 'userName', sortingName: 'userId.firstName' });
      this.gridData.columnInfo.push({ label: 'Date & Time', propertyName: 'importDate', sortingName: 'importDate' });
      this.gridData.columnInfo.push({ label: 'Total Imported', propertyName: 'Total', sortingName: 'totalRecordsCount' });
      this.gridData.columnInfo.push({ label: 'Added', propertyName: 'Add', sortingName: 'addedRecordsCount' });
      this.gridData.columnInfo.push({ label: 'Updated', propertyName: 'Update', sortingName: 'updatedRecordsCount' });
      this.gridData.columnInfo.push({ label: 'Skipped', propertyName: 'Skip', sortingName: 'skippedRecordsCount' });
    }
    if(this.moduleName == 'importDWM'){
      this.gridData.columnInfo.push({ label: 'Sr.No.', propertyName: 'sNo', sortingName: 'id' });
      this.gridData.columnInfo.push({ label: 'User Name', propertyName: 'userName', sortingName: 'userId.firstName' });
      this.gridData.columnInfo.push({ label: 'Date & Time', propertyName: 'importDate', sortingName: 'importDate' });
      this.gridData.columnInfo.push({ label: 'Total Imported', propertyName: 'Total', sortingName: 'totalRecordsCount' });
      this.gridData.columnInfo.push({ label: 'Added', propertyName: 'Add', sortingName: 'addedRecordsCount' });
      this.gridData.columnInfo.push({ label: 'Skipped', propertyName: 'Skip', sortingName: 'skippedRecordsCount' });
    }
  }
  
  renderData(listData: any) {
    let cnt = this.gridData.currentPage * 25;
    this.gridData.columnData = [];
    for (let i = 0; i < listData?.length; i++) {
     if(this.moduleName != 'importDWM'){
      this.gridData.columnData.push({
        sNo: ++cnt,
        id: listData[i].id,
        userName: listData[i].userId?.firstName+ ' '+ listData[i].userId?.lastName,
        importDate: this.datePipe.transform(listData[i]?.importDate, 'dd-MM-yyyy |  hh:mm a'),
        Total: listData[i]?.addedRecordsCount + listData[i]?.updatedRecordsCount + listData[i]?.skippedRecordsCount,
        Add: listData[i]?.addedRecordsCount,
        Update: listData[i]?.updatedRecordsCount?listData[i]?.updatedRecordsCount:0,
        Skip: listData[i]?.skippedRecordsCount,
      });
     }
     if(this.moduleName == 'importDWM'){
      this.gridData.columnData.push({
        sNo: ++cnt,
        id: listData[i].id,
        userName: listData[i].userId?.firstName+ ' '+ listData[i].userId?.lastName,
        importDate: this.datePipe.transform(listData[i]?.importDate, 'dd-MM-yyyy |  hh:mm a'),
        Total: listData[i]?.totalRecordsCount,
        Add: listData[i]?.addedRecordsCount,
        Update: listData[i]?.updatedRecordsCount?listData[i]?.updatedRecordsCount:0,
        Skip: listData[i]?.skippedRecordsCount,
      });
     }
    }
    this.isChangeDetected = !this.isChangeDetected
  }
  deleteMultipleRecord(data: any) {
  }
  pageNavigation(response: any) {
    this.currentPage = response.currentPageNumber - 1;
    this.renderData(response.data.plant);
  }
  backBtn() {
    if(this.moduleName == 'competencyImport'){
      this.router.navigate(['/home/hrportal/importFiles',{module:this.moduleName,year: this.selectedYear}]);
    }else{
      this.router.navigate(['/home/hrportal/importFiles',{module:this.moduleName}]);
    }
  }
  onClickMobileBackBtn() {
    // this.router.navigate(['/home/mobileHomePage']);
  }
  addRecord() {
  }
  editRecord(data: any) {
    let id = data.find((item: any) => item.key == 'id').value;
    // this.router.navigate(['/home/import-history', { id: id, operation: 'Edit' }]);
  }
  sortAsending(data: any) {
    if(this.moduleName == 'importemployee'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "search": this.searchString,
        "status": 0,
        "userType": ""
      }
      this.httpService.callPostService(this.config.searchImportHistory + '?page=' + 0+ '&size=' + this.selectedSizeToShowData + '&sort=' + data?.sortingName + ',asc',request).subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'importgoals'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "entityName": null,
        "search": this.searchString,
        "status": 0,
        "userType": ""    
      }
      this.httpService.callPostService(this.config.goalSettingSearchImportHistory + '?page=' + 0+ '&size=' + this.selectedSizeToShowData + '&sort=' + data?.sortingName + ',asc',request).subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'importgoals'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "entityName": null,
        "search": this.searchString,
        "status": 0,
        "userType": ""    
      }
      this.httpService.callPostService(this.config.goalSettingSearchImportHistory + '?page=' + 0+ '&size=' + this.selectedSizeToShowData + '&sort=' + data?.sortingName + ',asc',request).subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'importDWM'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "entityName": null,
        "search": this.searchString,
        "status": 0
      }
      this.httpService.callPostService(this.config.DWMSearchImportHistory+'?page=' + 0+ '&size=' + this.selectedSizeToShowData+'&sort='+ data?.sortingName + ',asc',request).subscribe((data: any) => {
         this.loadingService.dismissLoader();
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'competencyImport'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "search": this.searchString,
        "status": 0,
        "userType": ""
      };
      this.httpService.callPostService(this.config.searchImportHistoryCompetency+'?page=' + data+ '&size=' + this.selectedSizeToShowData+'&sort='+data?.sortingName + ',asc', request)
        .subscribe((response: any) => {
          this.currentPage = 0;
          this.gridData.totalNoOfPages = response.data?.totalPages;
          this.gridData.totalCount = response.data?.total;
          this.gridData.currentPage = response.data?.currentPageNumber;
          this.renderData(response.data?.history);
        }, (error: any) => {
          console.error('Error fetching import history data:', error);
      });
    }
  }
  sortDesending(data: any) {
    if(this.moduleName == 'importemployee'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "search": this.searchString,
        "status": 0,
        "userType": ""
      }
      this.httpService.callPostService(this.config.searchImportHistory + '?page=' + 0 + '&size=' + this.selectedSizeToShowData+ '&sort=' + data?.sortingName+ ',desc',request).subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'importgoals'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "entityName": null,
        "search": this.searchString,
        "status": 0,
        "userType": ""    
      }
      this.httpService.callPostService(this.config.goalSettingSearchImportHistory + '?page=' + 0+ '&size=' + this.selectedSizeToShowData + '&sort=' + data?.sortingName + ',desc',request).subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'importDWM'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "entityName": null,
        "search": this.searchString,
        "status": 0
      }
      this.httpService.callPostService(this.config.DWMSearchImportHistory+'?page=' + 0+ '&size=' + this.selectedSizeToShowData+'&sort='+ data?.sortingName + ',desc',request).subscribe((data: any) => {
        this.loadingService.dismissLoader();
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'competencyImport'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "search": this.searchString,
        "status": 0,
        "userType": ""
      };
      this.httpService.callPostService(this.config.searchImportHistoryCompetency+'?page=' + 0+ '&size=' + this.selectedSizeToShowData+'&sort='+data?.sortingName + ',desc', request)
        .subscribe((response: any) => {
          this.currentPage = 0;
          this.gridData.totalNoOfPages = response.data?.totalPages;
          this.gridData.totalCount = response.data?.total;
          this.gridData.currentPage = response.data?.currentPageNumber;
          this.renderData(response.data?.history);
        }, (error: any) => {
          console.error('Error fetching import history data:', error);
      });
    }
  }
  pageChange(data: any) {
    if(this.moduleName == 'importemployee'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "search": this.searchString,
        "status": 0,
        "userType": ""
      }
      this.httpService.callPostService(this.config.searchImportHistory + '?page=' + data + '&size=' + this.selectedSizeToShowData,request).subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'importgoals'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "entityName": null,
        "search": this.searchString,
        "status": 0,
        "userType": ""    
      }
      this.httpService.callPostService(this.config.goalSettingSearchImportHistory + '?page=' + data + '&size=' + this.selectedSizeToShowData,request).subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'importDWM'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "entityName": null,
        "search": this.searchString,
        "status": 0
      }
      this.httpService.callPostService(this.config.DWMSearchImportHistory+'?page=' + data+ '&size=' + this.selectedSizeToShowData+'&sort=createdAt' + ',desc',request).subscribe((data: any) => {
        this.loadingService.dismissLoader();
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'competencyImport'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "search": this.searchString,
        "status": 0,
        "userType": ""
      };
      this.httpService.callPostService(this.config.searchImportHistoryCompetency+'?page=' + data+ '&size=' + this.selectedSizeToShowData+'&sort=createdAt' + ',desc', request)
        .subscribe((response: any) => {
          this.currentPage = 0;
          this.gridData.totalNoOfPages = response.data?.totalPages;
          this.gridData.totalCount = response.data?.total;
          this.gridData.currentPage = response.data?.currentPageNumber;
          this.renderData(response.data?.history);
        }, (error: any) => {
          console.error('Error fetching import history data:', error);
      });
    }
  }
  onSelectSizeData(size: any) {
    this.selectedSizeToShowData = size
    if(this.moduleName == 'importemployee'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "search": this.searchString,
        "status": 0,
        "userType": ""
      }
      this.httpService.callPostService(this.config.searchImportHistory + '?page=' + 0 + '&size=' + size,request).subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'importgoals'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "entityName": null,
        "search": this.searchString,
        "status": 0,
        "userType": ""    
      }
      this.httpService.callPostService(this.config.goalSettingSearchImportHistory+'?page=' + 0+ '&size=' + this.selectedSizeToShowData+'&sort=createdAt' + ',desc',request).subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'importDWM'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "entityName": null,
        "search": this.searchString,
        "status": 0
      }
      this.httpService.callPostService(this.config.DWMSearchImportHistory+'?page=' + 0+ '&size=' + this.selectedSizeToShowData+'&sort=createdAt' + ',desc',request).subscribe((data: any) => {
         this.loadingService.dismissLoader();
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.history);
      });
    }
    if(this.moduleName == 'competencyImport'){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "search": this.searchString,
        "status": 0,
        "userType": ""
      };
      this.httpService.callPostService(this.config.searchImportHistoryCompetency+'?page=' + 0+ '&size=' + this.selectedSizeToShowData+'&sort=createdAt' + ',desc', request)
        .subscribe((response: any) => {
          this.currentPage = 0;
          this.gridData.totalNoOfPages = response.data?.totalPages;
          this.gridData.totalCount = response.data?.total;
          this.gridData.currentPage = response.data?.currentPageNumber;
          this.renderData(response.data?.history);
        }, (error: any) => {
          console.error('Error fetching import history data:', error);
      });
    }
  }
  searchData(data: any) {
    var search = ''
    this.searchString = data;
    if (data == '') {
      this.searchString = null;
      if(this.moduleName == 'importemployee'){
        this.getImportHistory();
      }
      if(this.moduleName == 'importgoals'){
        this.getImportHistoryGoals();
      }
      if(this.moduleName == 'importDWM'){
        this.getImportDWM();
      }
      if(this.moduleName == 'competencyImport'){
        this.getCompetencyHistoryData();
      }
      return;
    }
    if (data.length > 1) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            if(this.moduleName == 'importemployee'){
              this.getImportHistory();
            }
            if(this.moduleName == 'importgoals'){
              this.getImportHistoryGoals();
            }
            if(this.moduleName == 'importDWM'){
              this.getImportDWM();
            }
            if(this.moduleName == 'competencyImport'){
              this.getCompetencyHistoryData();
            }
          },
            500);
        }
      },
        1500);
    }
  }
  refreshData() {
    this.loadingService.simpleLoaderWithDuration();
    this.searchString = null;
    this.gridData.currentPage = 0;
    this.selectedSizeToShowData = 25;
    this.currentPage = 0;
    if(this.moduleName == 'importemployee'){
      this.getImportHistory();
    }
    if(this.moduleName == 'importgoals'){
      this.getImportHistoryGoals();
    }
    if(this.moduleName == 'importDWM'){
      this.getImportDWM();
    }
    if(this.moduleName == 'competencyImport'){
      this.getCompetencyHistoryData();
    }
    this.loadingService.dismissLoader();
  }
  exportReport(selectedIds:any) {
  }
  showDatails(data: any) {
    let id = data.find((item: any) => item.key == 'id').value;
    this.router.navigate(['/home/import-history', { id: id, operation: 'Show' }]);
  }
  deleteRecords(data: any) {
  }
  getImportHistory() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "search": this.searchString,
      "status": 0,
      "userType": ""
    }
    this.httpService.callPostService(this.config.searchImportHistory+'?page=' + 0+ '&size=' + this.selectedSizeToShowData+'&sort=createdAt' + ',desc',request).subscribe((data: any) => {
      this.currentPage = 0;
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.renderData(data.data?.history);
    });
  }

  getIncidentReportByID() {
  }

  showDetailsWithColumn(data: any) {
    const dialogConfig = new MatDialogConfig();

    // dialogConfig.height = '70%';
    // dialogConfig.width = '100%';
    dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidth992AndBelow;
    dialogConfig.data = {
      colName: data?.colName,
      id: data?.data.find((item: any) => item.key == 'id').value,
      module:this.moduleName
    };
    dialogConfig.panelClass =  ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'];
    this.dialog.open(ShowImportDataComponent, dialogConfig);

    // const dialogRef = this.dialog.open(ShowImportDataComponent, {
    //   disableClose: true,
    //   height: '60%',
    //   width: '100%',
    //   data: {
    //     colName: data?.colName,
    //     id: data?.data.find((item: any) => item.key == 'id').value,
    //   },
    // });
    // dialogRef.afterClosed().subscribe(result => { });
  }

  //Goals
  getImportHistoryGoals(){
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "entityName": null,
      "search": this.searchString,
      "status": 0, 
      "userType": ""   
    }
    this.httpService.callPostService(this.config.goalSettingSearchImportHistory+'?page=' + 0+ '&size=' + this.selectedSizeToShowData+'&sort=createdAt' + ',desc',request).subscribe((data: any) => {
      this.currentPage = 0;
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.renderData(data.data?.history);
    });
  }

  // DWM
  getImportDWM(){
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "entityName": null,
      "search": this.searchString,
      "status": 0
    }
    this.httpService.callPostService(this.config.DWMSearchImportHistory+'?page=' + 0+ '&size=' + this.selectedSizeToShowData+'&sort=createdAt' + ',desc',request).subscribe((data: any) => {
       this.loadingService.dismissLoader();
      this.currentPage = 0;
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.renderData(data.data?.history);
    
    });
  }

  //competency Get History
  getCompetencyHistoryData() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "search": this.searchString,
      "status": 0,
      "userType": ""
    };
    this.httpService.callPostService(this.config.searchImportHistoryCompetency+'?page=' + 0+ '&size=' + this.selectedSizeToShowData+'&sort=createdAt' + ',desc', request)
      .subscribe((response: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = response.data?.totalPages;
        this.gridData.totalCount = response.data?.total;
        this.gridData.currentPage = response.data?.currentPageNumber;
        this.renderData(response.data?.history);
      }, (error: any) => {
        console.error('Error fetching import history data:', error);
    });
  }
  
}

